<script>
import IntegrationHooks from './IntegrationHooks.vue';

export default {
  components: {
    IntegrationHooks,
  },
};
</script>

<template>
  <IntegrationHooks integration-id="shopify" />
</template>
